export const ASTERS_API_DOCS_LINK = 'https://docs.asters.ai/'
